import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "password-tip" }
const _hoisted_2 = { class: "otp-container" }

import { ref } from "vue";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons-vue";
import Vue3OtpInput from "vue3-otp-input";

// 组件属性定义

export default /*@__PURE__*/_defineComponent({
  __name: 'OTPInput',
  props: {
  color: {
    type: String,
    default: "#4749ad",
  },
},
  emits: ["update:code"],
  setup(__props, { emit: __emit }) {

const props = __props;

// 自定义事件
const emit = __emit;

// 响应式数据
const otpValue = ref("");
const isOtpDisabled = ref(false);
const showPassword = ref(false);
const hiddenPasswordRef = ref<HTMLInputElement | null>(null);

// 浏览器/扩展自动填充时写入的是隐藏的 password 框，同步到 OTP 六格
function onHiddenPasswordInput(e: Event) {
  const input = e.target as HTMLInputElement;
  const raw = (input.value || "").replace(/\D/g, "").slice(0, 6);
  if (raw.length === 6) {
    otpValue.value = raw;
    emit("update:code", raw.split(""));
    input.value = ""; // 清空隐藏框，避免重复触发
  }
}

// 切换密码显示/隐藏
const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

// 用户通过 OTP 六格输入完成后，把值写回隐藏的 password 框，便于浏览器识别并提示「是否保存密码」
function syncOtpToHiddenPassword(value: string) {
  const normalized = value.replace(/\D/g, "").slice(0, 6);
  if (normalized.length === 6 && hiddenPasswordRef.value) {
    hiddenPasswordRef.value.value = normalized;
  }
}

// 处理OTP输入变化：不做“过滤/拦截”，交给组件本身保证输入合法性
const handleOtpChange = (value: string | string[]) => {
  const strValue = Array.isArray(value) ? value.join("") : value;
  const normalized = strValue.slice(0, 6);
  const codeArray = normalized.padEnd(6, "").split("").slice(0, 6);
  emit("update:code", codeArray);
  syncOtpToHiddenPassword(normalized);
};

// 处理OTP输入完成：不做“过滤/拦截”，交给组件本身保证输入合法性
const handleOtpComplete = (fullValue: string) => {
  const normalized = String(fullValue || "").slice(0, 6);
  const codeArray = normalized.padEnd(6, "").split("").slice(0, 6);
  emit("update:code", codeArray);
  syncOtpToHiddenPassword(normalized);
};

// NOTE:
// IME / 特殊输入兜底拦截逻辑先不启用，优先依赖组件原生能力（inputType=password/number）。
// 如果后续仍发现可以输入字母/中文，再考虑在 wrapper 上启用捕获阶段拦截。
//
// const DIGIT_RE = /^\d+$/;
// const syncFromString = (raw: string) => { ... };
// const handleBeforeInput = (e: InputEvent) => { ... };
// const handleKeydown = (e: KeyboardEvent) => { ... };
// const handlePaste = (e: ClipboardEvent) => { ... };
// const handleCompositionEnd = () => { ... };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "content ds-otp",
    style: _normalizeStyle({ '--focus-border-color': props.color })
  }, [
    _createElementVNode("input", {
      ref_key: "hiddenPasswordRef",
      ref: hiddenPasswordRef,
      type: "password",
      autocomplete: "current-password",
      name: "current-password",
      class: "otp-hidden-password",
      maxlength: "6",
      inputmode: "numeric",
      tabindex: "-1",
      "aria-label": "授权密码",
      onInput: onHiddenPasswordInput
    }, null, 544),
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("p", null, [
        _createElementVNode("i", null, "*"),
        _createTextVNode("请输入 6 位数字授权密码：")
      ], -1)),
      _createElementVNode("div", {
        class: "eye-icon",
        onClick: togglePassword
      }, [
        (showPassword.value)
          ? (_openBlock(), _createBlock(_unref(EyeOutlined), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(EyeInvisibleOutlined), { key: 1 }))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["ds-otp-wrapper", { 'show-password': showPassword.value }])
      }, [
        _createVNode(_unref(Vue3OtpInput), {
          value: otpValue.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((otpValue).value = $event)),
          "num-inputs": 6,
          "input-classes": "otp-input",
          inputmode: "numeric",
          "input-type": "number",
          "should-auto-focus": true,
          "should-focus-order": true,
          conditionalClass: [
            'otp-input-1',
            'otp-input-2',
            'otp-input-3',
            'otp-input-4',
            'otp-input-5',
            'otp-input-6',
          ],
          "is-disabled": isOtpDisabled.value,
          onOnChange: handleOtpChange,
          onOnComplete: handleOtpComplete
        }, null, 8, ["value", "is-disabled"])
      ], 2)
    ])
  ], 4))
}
}

})